import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { KeysOfType } from 'src/app/helpers/utility-functions';
import Asset from 'src/app/model/asset';
import LoggedAction from 'src/app/model/logged-action';
import { User } from 'src/app/model/user';
import { ImmoIPImmoTaskChangesObject } from 'src/app/services/immo-ip-placer-offline-changes/immo-ip-immo-task-changes/immo-ip-immo-task-changes-object';
import { ToDoItem } from 'src/app/services/immo-ip-placer-offline-changes/model/to-do-item';

export class ImmoIPPlacerImmoTaskChangesFunctions {
  private constructor() {}

  static changeExecutionStarted: SetImmoTaskChangeFunction<boolean> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    executionStarted: boolean
  ) => {
    immoTaskChanges.executionStarted = executionStarted;
  };

  static changeExecutionFeedback: SetImmoTaskChangeFunction<string> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    executionFeedback: string
  ) => {
    immoTaskChanges.executionFeedback = executionFeedback;
  };

  static changeExecuted: SetImmoTaskChangeFunction<boolean> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    executed: boolean
  ) => {
    immoTaskChanges.executed = executed;
  };

  static initializeExecutedRegistration(date: Date, user: User): LoggedAction {
    if (date != null && user != null) {
      const simpleUser = new User();
      simpleUser.id = user.id;
      simpleUser.firstName = user.firstName;
      simpleUser.lastName = user.lastName;
      const executedRegistration = new LoggedAction();
      executedRegistration.date = date;
      executedRegistration.by = simpleUser;
      return executedRegistration;
    } else {
      return null;
    }
  }

  static changeExecutedRegistration: SetImmoTaskChangeFunction<LoggedAction> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    executedRegistration: LoggedAction
  ) => {
    immoTaskChanges.executedRegistration = executedRegistration;
  };

  static addOfflineAssets: SetImmoTaskChangeFunction<Asset[]> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    assets: Asset[]
  ) => {
    if (immoTaskChanges.offlineAssets == null) {
      immoTaskChanges.offlineAssets = [];
    }
    immoTaskChanges.offlineAssets.push(...assets);
  };

  static deleteFromOfflineAssets: SetImmoTaskChangeFunction<string> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    localFileUuid: string
  ) => {
    if (CollectionHelper.isPopulated(immoTaskChanges.offlineAssets)) {
      CollectionHelper.filterInPlace(
        immoTaskChanges.offlineAssets,
        oa => oa.localFileUuid !== localFileUuid
      );
    }
  };

  static addToDeleteAssets: SetImmoTaskChangeFunction<string> = (
    immoTaskChanges: ImmoIPImmoTaskChangesObject,
    uuid: string
  ) => {
    if (immoTaskChanges.toDeleteAssetUuids == null) {
      immoTaskChanges.toDeleteAssetUuids = [];
    }
    immoTaskChanges.toDeleteAssetUuids.push(uuid);
  };
}

export type SetImmoTaskChangeFunction<I> = (
  immoTaskChanges: ImmoIPImmoTaskChangesObject,
  input: I
) => void;

export type ImmoTaskToDoItemProp = KeysOfType<
  ImmoIPImmoTaskChangesObject,
  ToDoItem
>;

export type SetImmoTaskToDoItemFunction = (
  immoTaskChanges: ImmoIPImmoTaskChangesObject,
  toDoItem: ToDoItem,
  prop: ImmoTaskToDoItemProp
) => void;
